import type { Category } from '@inmotion/models';

export default function isSequentialViewingCategory(category: Category): boolean {
  return Boolean(category.useSequentialViewing) && category.visibility !== 'Public';
}
